import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap'
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { CreateUser, GetUsers } from "../../services/users.service";
import { toast } from "react-toastify";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { FadeLoader } from "react-spinners";
import { constants, genders } from "../../utils/constants";
import { GetCategory } from "../../services/category.service";
import Select from "react-select";
import { GetRole } from "../../services/role.service";
import { uploadToS3 } from "../../utils/helpers";
import { GetState } from "../../services/state.service";
import { GetCity } from "../../services/city.service";

function AddNewUser(props) {
    let history = useHistory();
    const [data, setData] = useState([]);
    const [pass, TogglePass] = useState(true);
    const [age, setAge] = useState({ format: "mm/dd/yyyy" })
    const [confPass, ToggleConfPass] = useState(true);
    const [confirmPass, setConfirmPass] = useState(true);
    const [loader, setLoader] = useState(false);
    const [selectedRole, setSelectedRole] = useState();
    const [image, setImage] = useState()
    const [file, setFile] = useState(null)
    const [isUpload, setIsUpload] = useState(false)
    const [role, setRole] = useState([]);
    const { register, watch, setError, clearErrors, setValue, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    });
    const [states, setStates] = useState([]); // Add this state for storing states
    const [selectedState, setSelectedState] = useState(null); // Add this state for selected state
    const [cities, setCities] = useState([]); // Add state for cities
    const [selectedCity, setSelectedCity] = useState(null);



    const regex = new RegExp("^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$")

    // Calculate the maximum date (18 years before today)
    const today = new Date();
    const maxDate = new Date(today.setFullYear(today.getFullYear() - 18)).toISOString().split('T')[0]; // 18 years ago

    // const maxDate = new Date().toISOString().split('T')[0]; // Get today's date in ISO format


    const password = useRef({});
    password.current = watch("password", "");
    const onSubmit = async data => {
        let uploadImage = null;
        setLoader(true)
        if (file) {
            clearErrors('media')
            if (file.type.startsWith('image/')) {
                clearErrors('media')
            } else {
                setError('media', { message: 'Invalid file type' })
                return false;
            }
            uploadImage = await uploadToS3(file.type, file.name, file, 'users');
        } else {
            // setError('media',{message:"Image is required"})
        }


        if (uploadImage) {
            if (!uploadImage) {
                setLoader(false)
                toast.error(uploadImage.message);
                return false;
            }
        }
        // else {
        //     setLoader(false)
        //     toast.error('Can\'t Upload Image');
        //     return false;
        // }
        data.media = uploadImage;
        await CreateUser({
            fullName: data.fullName,
            image: data.media,
            email: data.email,
            address: data.address,
            // phone: data.phone || null,
            // bio: data.bio || null,
            additionalFields: { dob: data.dob },
            // gender:data.gender,
            // type:'User',
            password: data.password,
            authType: 'email',
            role: '10',
            profileImage: data.media,
            state: selectedState?.value || null, // Add state to the payload
            city: selectedCity?.value || null,
            // password_confirmation: data.password_confirmation,
            // device_type: 'web',
            // device_token: 'user',

        }).then(async (data) => {
            setLoader(false)
            if (data.status) {
                // await createUser(data.data.user).then(() => {
                toast.success(data.message);
                history.push('/manage-users');
                // })
            } else {
                if (data.status === false && data.message.includes('Duplicate entry')) {
                    setError('email', { message: 'This email is already registered.' });
                } else {
                    setError('email', { message: '' });
                }
                setLoader(false)

                toast.error(data.message);
            }
        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })
    };

    const fetchStates = async () => {
        try {
            const response = await GetState();
            if (response.status) {
                // Assuming the response has a data array of states
                const stateOptions = response.data.map(state => ({
                    value: state,
                    label: state.name
                }));
                setStates(stateOptions);
            }
        } catch (error) {
            toast.error("Failed to fetch states");
        }
    };

    const fetchCities = async () => {
        if (selectedState?.value) {
            try {
                const response = await GetCity(1, selectedState.value.id);
                if (response.status) {
                    const cityOptions = response.data.map(city => ({
                        value: city,
                        label: city.name
                    }));
                    setCities(cityOptions);
                    // Reset city selection when state changes
                    setSelectedCity(null);
                    setValue('city', null);
                }
            } catch (error) {
                toast.error("Failed to fetch cities");
            }
        } else {
            // Reset cities if no state is selected
            setCities([]);
        }
    };

    useEffect(() => {
        fetchStates();
    }, []);

    useEffect(() => {
        fetchCities();
    }, [selectedState]);

    const onAgeChange = (e) => {
        const object = e.target.value;
        const date = new Date(object);
        setAge(date.toLocaleDateString())
    }


    const uploadFile = async (fileInput) => {

        let fileUrl = URL.createObjectURL(fileInput[0])
        setImage(fileUrl)
        setFile(fileInput[0])
        setIsUpload(true)
        const fileType = fileInput[0]?.type;

    }

    const validateMedia = (fileList) => {
        const file = fileList[0];
        // if (file && file.size > 5 * 1024 * 1024) {
        //     return 'Image size should be less than 5MB';
        // }else if(!file){
        //     return 'Image is required';
        // }
        return true; // Validation passed
    };
    return (
        <div className="AddNewUser">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">Create User</h3>
            <hr />
            <Row>
                <Col xs={12} sm={12} md={10} lg={12} xl={6}>
                    <Form encType="multipart/form-data" className="formAddUser" autoComplete="off" role="presentation" onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="image">
                                    <Form.Label>Image <Form.Text className=" text-muted" style={{ fontSize: ".675em" }}>(Max upload file size: 5 MB)</Form.Text> </Form.Label>
                                    <input
                                        {...register('media', {
                                            validate: validateMedia // Use the custom validation function
                                        })}
                                        onChange={(e) => uploadFile(e.target.files)}
                                        type='file'
                                        accept={'.jepg,.jpg,.png'}
                                        class="custom-file-input"
                                        id='image'
                                    />

                                    <br />
                                    {errors.media && <Form.Text
                                        className=" validationText hasError">{errors.media.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                        </Row>
                        {isUpload ?
                            <Row>
                                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <ul className={"list-inline list-variations"}>
                                        <li className={"list-inline-item d-flex justify-content-between mb-0"}>
                                            <img src={image} width="50%" height="50%" />
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                            : ""
                        }
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="name">
                                    <Form.Label>Full Name*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Full Name"
                                        id={"formSignUpName"}
                                        {...register('fullName', {
                                            required: {
                                                value: "required",
                                                message: "Full Name is required"
                                            },
                                            pattern: {
                                                value: /^(?!\s).*$/,
                                                message: "Full Name should not start with a space"
                                            },
                                            minLength: {
                                                value: 2,
                                                message: "Min length is 2"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="text"
                                    />
                                    {errors.fullName && <Form.Text
                                        className="text-muted validationText hasError">{errors.fullName.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Email Address"
                                        autocomplete="off"
                                        {...register('email', {
                                            required: {
                                                value: "required",
                                                message: "Email is required"
                                            },
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Entered value does not match email format"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="email" />
                                    {errors.email && <Form.Text
                                        className="text-muted validationText hasError">{errors.email.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={12} md={8} lg={6} xl={6} style={{ zIndex: 1000 }}>
                                <Form.Group className="mb-3" controlId="state" >
                                    <Form.Label>State*</Form.Label>
                                    <Select
                                        options={states}
                                        placeholder="Select State"
                                        {...register('state', {
                                            required: {
                                                value: true,
                                                message: "State is required"
                                            }
                                        })}
                                        onChange={(selectedOption) => {
                                            setSelectedState(selectedOption);
                                            setValue('state', selectedOption?.value);
                                        }}
                                    />
                                    {errors.state && <Form.Text
                                        className="text-muted validationText hasError">{errors.state.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={12} md={8} lg={6} xl={6} style={{ zIndex: 1000 }}>
                                <Form.Group className="mb-3" controlId="city">
                                    <Form.Label>City*</Form.Label>
                                    <Select
                                        options={cities}
                                        placeholder="Select City"
                                        isDisabled={!selectedState}
                                        {...register('city', {
                                            required: {
                                                value: true,
                                                message: "City is required"
                                            }
                                        })}
                                        onChange={(selectedOption) => {
                                            setSelectedCity(selectedOption);
                                            setValue('city', selectedOption?.value);
                                        }}
                                        value={selectedCity}
                                    />
                                    {errors.city && <Form.Text
                                        className="text-muted validationText hasError">{errors.city.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            {/* <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Gender*</Form.Label>
                                    <Form.Select
                                        id={"gender"}
                                        type="text"
                                        placeholder="Select Gender"
                                        {...register("gender", {
                                                required: {
                                                    value: "required",
                                                    message: "Gender is required"
                                                }
                                            }
                                        )}
                                    >
                                        <option selected disabled value="">Select Gender</option>
                                        <option value={"Male"}>Male</option>
                                        <option value={"Female"}>Female</option>
                                        <option value={"Non-binary"}>Non-binary</option>
                                        <option value={"Transgender"}>Transgender</option>
                                        <option value={"Gender Neutral"}>Gender Neutral</option>
                                        <option value={"Agender"}>Agender</option>
                                        <option value={"Pangender"}>Pangender</option>
                                        <option value={"Two-spirit"}>Two-spirit</option>
                                        <option value={"Genderqueer"}>Genderqueer</option>
                                        <option value={"Third Gender"}>Third Gender</option>
                                        <option value={"Gender Fluid"}>Gender Fluid</option>
                                        <option value={"Other"}>Other</option>
                                    </Form.Select>
                                    {errors.gender && <Form.Text
                                        className=" validationText hasError">{errors.gender.message}</Form.Text>}
                                </Form.Group>
                            </Col> */}
                            {/*<Col  xs={12} sm={12} md={8} lg={6} xl={6}>*/}
                            {/*    <Form.Group className={"mb-3"} controlId="type">*/}
                            {/*        <Form.Label className='d-block'>Select Type*</Form.Label>*/}
                            {/*        <Form.Select className='formselect' aria-label="type" {...register('type', {*/}
                            {/*            required: {*/}
                            {/*                value: "required",*/}
                            {/*                message: "Type is required"*/}
                            {/*            }*/}
                            {/*        })}>*/}
                            {/*            <option value="Admin">Admin</option>*/}
                            {/*            <option value="User">User</option>*/}
                            {/*            <option value="Trainer">Trainer</option>*/}
                            {/*        </Form.Select>*/}
                            {/*        {errors.type && <Form.Text*/}
                            {/*            className=" validationText hasError">{errors.type.message}</Form.Text>}*/}
                            {/*    </Form.Group>*/}
                            {/*</Col>*/}
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>DOB*</Form.Label>
                                    <Form.Control
                                        id={"age"}
                                        placeholder="Enter Age"
                                        value={age.date}
                                        max={maxDate}
                                        maxLength={3}
                                        {...register('dob', {
                                            required: {
                                                value: "required",
                                                message: "DOB is required"
                                            },
                                            onChange: (e) => onAgeChange(e),
                                        })} type="date"
                                    />
                                    {errors.dob && <Form.Text
                                        className=" validationText hasError">{errors.dob.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            {/* <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="phone">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Phone"
                                        id={"formSignUpName"}
                                        maxLength={25}
                                        minLength={3}
                                        {...register('phone', {
                                            pattern: {
                                                value: regex,
                                                message: "Please enter valid phone number"
                                            },
                                            maxLength: {
                                                value: 25,
                                                message: "Max length is 25"
                                            },
                                        })} type="number"
                                    />
                                    {errors.phone && <Form.Text
                                        className="text-muted validationText hasError">{errors.phone.message}</Form.Text>}

                                </Form.Group>
                            </Col> */}
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="address">
                                    <Form.Label>Address*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Address"
                                        autocomplete="off"
                                        autofill="off"
                                        {...register('address', {
                                            required: {
                                                value: "required",
                                                message: "Address is required"
                                            },
                                            minLength: {
                                                value: 2,
                                                message: "Max length is 2"
                                            },
                                            maxLength: {
                                                value: 200,
                                                message: "Max length is 200"
                                            },
                                            validate: {
                                                notOnlySpaces: value => value.trim() !== "" || "Address cannot be only spaces"
                                            }
                                        })} type="text" />
                                    {errors.address && <Form.Text
                                        className="text-muted validationText hasError">{errors.address.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            {/* <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="text">
                                    <Form.Label>Bio</Form.Label>
                                    <textarea
                                        id='custom-text-area'
                                        rows={6} className={'w-100'}
                                        placeholder="Enter Bio"
                                        {...register('bio', {
                                            pattern:{
                                                value:/^(?!\s).*$/,
                                                message:"Bio should not start with a space"
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Min length is 3"
                                            },
                                            maxLength: {
                                                value: 300,
                                                message: "Max length is 300"
                                            },
                                            onChange: (e) => setValue('bio',e.target.value.trimStart()),
                                        })} type="text" />
                                    {errors.bio && <Form.Text
                                        className=" validationText hasError">{errors.bio.message}</Form.Text>}

                                </Form.Group>
                            </Col> */}
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <div className={"pass-field mb-3"}>
                                    <Form.Label>Password*</Form.Label>
                                    <InputGroup controlId="passowrd">
                                        <FormControl
                                            placeholder="Enter Password"
                                            autoComplete={"off"}
                                            maxLength={255}
                                            minLength={8}
                                            {...register('password', {
                                                required: {
                                                    value: "required",
                                                    message: "Password is required"
                                                },
                                                pattern: {
                                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                    message: 'Password should contain a mix of uppercase and lowercase letters, numbers, and special characters'
                                                },
                                                minLength: {
                                                    value: 8,
                                                    message: "Min length is 8"
                                                },
                                                maxLength: {
                                                    value: 255,
                                                    message: "Max length is 255"
                                                }
                                            })}
                                            type={pass ? "password" : "text"} />
                                        <Button variant="outline-secondary" id="button-addon2" onClick={() => TogglePass(!pass)}>
                                            {
                                                pass ? <FaEye /> : <FaEyeSlash />
                                            }
                                        </Button>
                                    </InputGroup>
                                    {errors.password && <Form.Text className="text-muted validationText hasError">{errors.password.message}</Form.Text>}
                                </div>
                            </Col>

                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <div className={"pass-field mb-3"}>
                                    <Form.Label>Confirm Password*</Form.Label>
                                    <InputGroup controlId="password_confirmation">
                                        <Form.Control
                                            placeholder="Enter Password Again"
                                            maxLength={25}
                                            minLength={3}
                                            {...register('password_confirmation', {
                                                required: {
                                                    value: "required",
                                                    message: "Confirm Password is required"
                                                },
                                                minLength: {
                                                    value: 8,
                                                    message: "Min length is 8"
                                                },
                                                validate: password.current ? value => value === password.current || "The passwords do not match" : '',
                                                maxLength: {
                                                    value: 255,
                                                    message: "Max length is 255"
                                                }
                                            })}
                                            type={confPass ? "password" : "text"}
                                        />
                                        <Button variant="outline-secondary" id="button-addon2" onClick={() => ToggleConfPass(!confPass)}>
                                            {
                                                confPass ? <FaEye /> : <FaEyeSlash />
                                            }
                                        </Button>
                                    </InputGroup>
                                    {errors.password_confirmation && <Form.Text className="text-muted validationText hasError">{errors.password_confirmation.message}</Form.Text>}
                                </div>
                            </Col>


                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                {loader ? <div className="spin-loader">
                                    <FadeLoader color={"#41D2D2"} height={10} />
                                </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                        value={"Create User"} />}
                            </Col>


                        </Row>
                    </Form>

                </Col>
            </Row>

        </div>
    )
}

export default AddNewUser




